/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiUsersMeGet } from '../fn/users/api-users-me-get';
import { ApiUsersMeGet$Params } from '../fn/users/api-users-me-get';
import { apiUsersMePatch } from '../fn/users/api-users-me-patch';
import { ApiUsersMePatch$Params } from '../fn/users/api-users-me-patch';
import { UpdateUserResult } from '../models/update-user-result';
import { UserDto } from '../models/user-dto';


/**
 * User information
 */
@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiUsersMeGet()` */
  static readonly ApiUsersMeGetPath = '/api/Users/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersMeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersMeGet$Response(params?: ApiUsersMeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    const obs = apiUsersMeGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersMeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersMeGet(params?: ApiUsersMeGet$Params, context?: HttpContext): Observable<UserDto> {
    const resp = this.apiUsersMeGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `apiUsersMePatch()` */
  static readonly ApiUsersMePatchPath = '/api/Users/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersMePatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersMePatch$Response(params?: ApiUsersMePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateUserResult>> {
    const obs = apiUsersMePatch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersMePatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersMePatch(params?: ApiUsersMePatch$Params, context?: HttpContext): Observable<UpdateUserResult> {
    const resp = this.apiUsersMePatch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UpdateUserResult>): UpdateUserResult => r.body)
    );
  }

}
